export interface FeatureTeachers {
 mitelAssistantEULA?: any;
}

export enum TagKeys {
  featureTeachers =  'viewedFeatureTeachers'
}
